module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('van-popup', {
    style: ({
      height: '70%'
    }),
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    on: {
      "click-overlay": _vm.onClose
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "请输关键字搜索"
    },
    on: {
      "input": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.city ? _vm.formData.province + '/' + _vm.formData.city : '',
      "input-align": "right",
      "label": "省市选择",
      "placeholder": "点击选择省市"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area,
      "columns-num": 2
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "44px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('van-cell-group', _vm._l((_vm.options), function(item, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "clickable": "",
        "label": (item.sex) + ' ' + item.grade + ' ' + item.num_str + ' ' + item.namekeyhtml,
        "v-if": index < _vm.limit
      },
      on: {
        "click": function($event) {
          return _vm.toggle(item)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "custom-title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('van-checkbox', {
      attrs: {
        "slot": "right-icon",
        "checked-color": "#FD2840"
      },
      slot: "right-icon",
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "createbtn"
  }, [_c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75ed4f56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/JianduPicker.vue
// module id = 2484
// module chunks = 0